import React from 'react';
import {
  LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import styles from '../../styles/Team.module.css';

const COLORS = {
  churnRate: '#ef4444',
  retentionRate: '#10b981',
  activityRate: '#6366f1',
  loyaltyRate: '#8b5cf6',
  engagementRate: '#f59e0b',
};

const LABELS = {
  churnRate: 'Churn Rate',
  retentionRate: 'Retention Rate',
  activityRate: 'Activity Rate',
  loyaltyRate: 'Loyalty Rate',
  engagementRate: 'Engagement Rate',
};

const AudienceMetricsTrendsChart = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className={styles.chartPlaceholder}>
        <div className={styles.emptyState}>
          <div className={styles.emptyStateIcon}>📈</div>
          <h3>No Audience Trend Data</h3>
          <p>Audience metrics trends will appear here once you have activity in the selected time period.</p>
        </div>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" stroke="#374151" strokeOpacity={0.3} />
        <XAxis dataKey="date" stroke="#9ca3af" fontSize={12} tickLine={false} axisLine={false} />
        <YAxis stroke="#9ca3af" fontSize={12} tickFormatter={v => `${v.toFixed(1)}%`} tickLine={false} axisLine={false} />
        <Tooltip
          contentStyle={{
            backgroundColor: '#1f2937',
            border: '1px solid #374151',
            borderRadius: '12px',
            color: '#f9fafb',
            boxShadow: '0 10px 25px rgba(0, 0, 0, 0.3)',
            backdropFilter: 'blur(10px)'
          }}
          formatter={(value, name) => [`${value.toFixed(1)}%`, LABELS[name] || name]}
          labelStyle={{ color: '#6366f1', fontWeight: 'bold' }}
        />
        <Legend wrapperStyle={{ paddingTop: '20px', color: '#f9fafb' }} />
        <Line type="monotone" dataKey="churnRate" stroke={COLORS.churnRate} strokeWidth={2} dot={false} name={LABELS.churnRate} />
        <Line type="monotone" dataKey="retentionRate" stroke={COLORS.retentionRate} strokeWidth={2} dot={false} name={LABELS.retentionRate} />
        <Line type="monotone" dataKey="activityRate" stroke={COLORS.activityRate} strokeWidth={2} dot={false} name={LABELS.activityRate} />
        <Line type="monotone" dataKey="loyaltyRate" stroke={COLORS.loyaltyRate} strokeWidth={2} dot={false} name={LABELS.loyaltyRate} />
        <Line type="monotone" dataKey="engagementRate" stroke={COLORS.engagementRate} strokeWidth={2} dot={false} name={LABELS.engagementRate} />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default AudienceMetricsTrendsChart; 